// src/pages/WebDevelopment.tsx
import styled from 'styled-components';

export default function WebDevelopment() {
  return (
    <Container>
      <Title>Web Development</Title>
      <Subtitle>
        Building scalable, maintainable, and high-performance websites & web apps.
      </Subtitle>
      <Content>
        <Section>
          <h3>Core Principles</h3>
          <ul>
            <li>Clean, maintainable code following best practices</li>
            <li>Modern frameworks like React.js, Next.js, and .NET Core</li>
            <li>Accessibility-first approach (WCAG compliance)</li>
            <li>SEO-friendly architecture</li>
          </ul>
        </Section>
        <Section>
          <h3>Technologies I Use</h3>
          <TechGrid>
            <TechItem>React</TechItem>
            <TechItem>TypeScript</TechItem>
            <TechItem>.NET Core</TechItem>
            <TechItem>MongoDB</TechItem>
            <TechItem>Node.js</TechItem>
            <TechItem>GraphQL</TechItem>
          </TechGrid>
        </Section>
        <Section>
          <h3>Why It Matters</h3>
          <p>
            In the digital era, your website is your brand's face. A well-built site
            loads fast, scales effortlessly, and provides a seamless user experience,
            boosting conversions and trust.
          </p>
        </Section>
      </Content>
    </Container>
  );
}

// Styled Components
const Container = styled.div`
  padding: 4rem 2rem;
  color: ${({ theme }) => theme.text};
`;

const Title = styled.h1`
  font-size: 2.8rem;
  color: ${({ theme }) => theme.primary};
  margin-bottom: 1rem;
`;

const Subtitle = styled.p`
  font-size: 1.2rem;
  margin-bottom: 3rem;
  color: ${({ theme }) => theme.text};
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
`;

const Section = styled.div`
  h3 {
    font-size: 1.5rem;
    margin-bottom: 1rem;
    color: ${({ theme }) => theme.primary};
  }
  ul {
    list-style: disc;
    padding-left: 1.5rem;
  }
`;

const TechGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 1rem;
`;

const TechItem = styled.div`
  background: rgba(255, 255, 255, 0.08);
  padding: 0.8rem;
  border-radius: 0.5rem;
  text-align: center;
  font-weight: bold;
  box-shadow: ${({ theme }) => theme.buttonShadow};
`;
